import React, { useState, Fragment } from "react";
import { connect } from "react-redux";
import { string, func } from "prop-types";
import { cacheFeedback } from "./helpers";
import * as style from "./styles.module.scss";
import FeedbackFace, { FeedbackFaceTypes } from "../FeedbackFace";
import Checkbox from "../../common/Checkbox/index";
import { timesheetSendFeedback } from "../../redux/actions/timesheetsActions";
import PulseBallLoader from "../../common/PulseBallLoader";

const getPickedFaceString = (pickedFace) => {
  switch (pickedFace) {
    case 1:
      return "Poor";
    case 2:
      return "Acceptable";
    case 3:
      return "Great";
    default:
      return "";
  }
};

const TimesheetFeedback = ({
  timesheetNumber,
  sendFeedback,
  jobTitle,
  orgName,
}) => {
  const initialFormState = {
    isDontAskChecked: false,
    pickedFace: undefined,
    feedbackContent: "",
  };
  const FeedbackStatus = Object.freeze({
    Shown: 1,
    Loading: 2,
    Finished: 3,
    Turnoff: 4,
    FinishedTurnoff: 5,
  });
  const [pickedFace, setPickedFace] = useState();
  const [isDontAskChecked, setDontAskChecked] = useState(false);
  const [feedbackContent, setFeedbackContent] = useState("");
  const [feedbackState, setFeedbackState] = useState(FeedbackStatus.Shown);
  const currentFormState = {
    isDontAskChecked,
    pickedFace,
    feedbackContent,
  };
  const isFormTouched = () =>
    JSON.stringify(initialFormState) === JSON.stringify(currentFormState);

  const resetForm = () => {
    setFeedbackContent("");
    setDontAskChecked(false);
    setPickedFace(undefined);
  };

  const handleFeedbackSubmit = () => {
    setFeedbackState(FeedbackStatus.Loading);
    if (pickedFace) {
      sendFeedback(
        timesheetNumber,
        getPickedFaceString(pickedFace),
        feedbackContent
      );
    }
    if (isDontAskChecked) {
      cacheFeedback();
    }
    if (pickedFace && isDontAskChecked) {
      setFeedbackState(FeedbackStatus.FinishedTurnoff);
    } else if (pickedFace && !isDontAskChecked) {
      setFeedbackState(FeedbackStatus.Finished);
    } else if (!pickedFace && isDontAskChecked) {
      setFeedbackState(FeedbackStatus.Turnoff);
    }

    resetForm();
  };
  switch (feedbackState) {
    case FeedbackStatus.Shown:
      return (
        <div>
          <div
            className={`${style.timesheet__feedback} px-xl-5 px-lg-5 py-lg-2 py-xl-2 px-md-4 py-md-2`}
          >
            <p className={`${style.timesheet__feedback_title}`}>
              How did you find the role of {jobTitle} at {orgName} this week?
            </p>
            <p className={`${style.timesheet__feedback_subtitle}`}>
              Your HRGO consultant will be informed of the feedback you submit.
            </p>
            <div className={`${style.timesheet__feedback_faces}`}>
              <div
                className={`${style.timesheet__feedback_face}`}
                onClick={() => setPickedFace(FeedbackFaceTypes.Sad)}
              >
                <FeedbackFace
                  type={FeedbackFaceTypes.Sad}
                  isPicked={pickedFace === FeedbackFaceTypes.Sad}
                  isGreyed={pickedFace && pickedFace !== FeedbackFaceTypes.Sad}
                />
                <p
                  className={`${style.timesheet__feedback_desc} ${
                    pickedFace === FeedbackFaceTypes.Sad &&
                    style.feedback__desc_picked
                  } ${
                    pickedFace &&
                    pickedFace !== FeedbackFaceTypes.Sad &&
                    style.feedback__desc_notpicked
                  }`}
                >
                  Poor
                </p>
              </div>
              <div
                className={`${style.timesheet__feedback_face}`}
                onClick={() => setPickedFace(FeedbackFaceTypes.Indifferent)}
              >
                <FeedbackFace
                  type={FeedbackFaceTypes.Indifferent}
                  isPicked={pickedFace === FeedbackFaceTypes.Indifferent}
                  isGreyed={
                    pickedFace && pickedFace !== FeedbackFaceTypes.Indifferent
                  }
                />
                <p
                  className={`${style.timesheet__feedback_desc} ${
                    pickedFace === FeedbackFaceTypes.Indifferent &&
                    style.feedback__desc_picked
                  } ${
                    pickedFace &&
                    pickedFace !== FeedbackFaceTypes.Indifferent &&
                    style.feedback__desc_notpicked
                  }`}
                >
                  Acceptable
                </p>
              </div>
              <div
                className={`${style.timesheet__feedback_face}`}
                onClick={() => setPickedFace(FeedbackFaceTypes.Happy)}
              >
                <FeedbackFace
                  type={FeedbackFaceTypes.Happy}
                  isPicked={pickedFace === FeedbackFaceTypes.Happy}
                  isGreyed={
                    pickedFace && pickedFace !== FeedbackFaceTypes.Happy
                  }
                />
                <p
                  className={`${style.timesheet__feedback_desc} ${
                    pickedFace === FeedbackFaceTypes.Happy &&
                    style.feedback__desc_picked
                  } ${
                    pickedFace &&
                    pickedFace !== FeedbackFaceTypes.Happy &&
                    style.feedback__desc_notpicked
                  }`}
                >
                  Great
                </p>
              </div>
            </div>
            {pickedFace && (
              <Fragment>
                <p className={style.timesheet__feedback_title}>
                  Do you have any additional feedback?
                </p>
                <textarea
                  onChange={(e) => setFeedbackContent(e.target.value)}
                  className={style.timesheet__feedback_textarea}
                ></textarea>
              </Fragment>
            )}
            <Checkbox
              isChecked={isDontAskChecked}
              onClick={() => setDontAskChecked(!isDontAskChecked)}
              label="Don't ask me for feedback again"
            />
            <button
              className={`btn ${style.timesheet__feedback_submit} mt-1 font-weight-bold`}
              onClick={handleFeedbackSubmit}
              disabled={isFormTouched()}
            >
              Submit
            </button>
          </div>
        </div>
      );
    case FeedbackStatus.Loading:
      return (
        <div className={style.timesheet__feedback_large}>
          <PulseBallLoader />
          <h2 className="text-center">Submitting your feedback</h2>
        </div>
      );
    case FeedbackStatus.Finished:
      return (
        <div className={style.timesheet__feedback_large}>
          <h2 className={`text-center ${style.feedback__title}`}>
            Your feedback was submitted - thank you!
          </h2>
        </div>
      );
    case FeedbackStatus.Turnoff:
      return (
        <div className={style.timesheet__feedback_large}>
          <h2 className={`text-center ${style.feedback__title}`}>
            Feedback has been turned off
          </h2>
          <b className="text-center">
            You won&apos;t be asked for feedback for 3 months when using this
            machine.
          </b>
        </div>
      );
    case FeedbackStatus.FinishedTurnoff:
      return (
        <div className={style.timesheet__feedback_large}>
          <h2 className={`text-center ${style.feedback__title}`}>
            Your feedback was submitted - thank you!
          </h2>
          <b className="text-center">
            You won&apos;t be asked for feedback for 3 months when using this
            machine.
          </b>
        </div>
      );

    default:
      return <Fragment></Fragment>;
  }
};

TimesheetFeedback.propTypes = {
  timesheetRef: string,
  sendFeedback: func,
  jobTitle: string,
  orgName: string,
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  sendFeedback: timesheetSendFeedback,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

export default withRedux(TimesheetFeedback);
